import * as React from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import Modal from "@mui/material/Modal"
import { CustomButton } from "./CommonComponents"
import { FormField } from "./Fields"
import HighlightOffIcon from "@mui/icons-material/HighlightOff"
import { Divider } from "@mui/material"
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  // p: 3,
  borderRadius: "10px",
}

function BasicModal(props) {
  const {
    title,
    text,
    buttontext1,
    buttontext2,
    show,
    Bfunction2,
    onClose,
    onSubmit,
    children,
    disableButton2 = false,
    showSecondButton = true,
    modalStyles = {},
    modalStyleClassName = "",
    showFooter = true,
    headerStyles = {}
  } = props
  const [open, setOpen] = React.useState(show)
  const handleOpen = () => setOpen(true)
  const handleClose = () => {
    setOpen(false)
    onClose()
  }

  const handleSubmit = () => {
    console.log("jhand")
    // setOpen(false)
    if (onSubmit) {
      onSubmit()
    }
  }

  React.useEffect(() => {
    setOpen(show)
  }, [show])

  return (
    <div>
      {/* <Button onClick={handleOpen}>Open modal</Button> */}
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleClose(event, reason);
          }
        }}
      >
        <Box sx={{ ...modalStyles }} className={`basic-modal-box ${modalStyleClassName}`}>
          <div
            className="row-between"
            style={{ padding: "15px 20px", ...headerStyles }}
          >
            <Typography id="modal-modal-title" variant="h8" component="h2">
              {title}
            </Typography>

            <HighlightOffIcon
              sx={{ cursor: "pointer" }}
              size={30}
              onClick={handleClose}
            />
          </div>
          <Divider />

          {children}

          {showFooter && (
            <>
              <Divider />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  marginTop: 0,
                  padding: "20px",
                }}
              >
                <CustomButton
                  text="Cancel"
                  variant="outlined"
                  sx={{ fontWeight: "bold" }}
                  onClick={handleClose}
                />
                {showSecondButton && (
                  <CustomButton
                    text="Submit"
                    sx={{ marginLeft: 2, fontWeight: "bold" }}
                    disabled={disableButton2}
                    onClick={handleSubmit}
                  />
                )}
              </Box>
            </>
          )}
        </Box>
      </Modal>
    </div>
  )
}

export default BasicModal
